import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

type Context = { type: string; key: string; pageId?: string };

@Injectable({
    providedIn: 'root'
})
export class SiteContextService {
    private readonly contextRs$: ReplaySubject<Context> = new ReplaySubject(1);
    public lastNavigationWasPopstate: boolean = false;

    public context$ = this.contextRs$.asObservable();

    constructor(
        @Inject(DOCUMENT)
        private document: Document,
        private router: Router
    ) {
        this.router.events.pipe(filter((e): e is NavigationStart => e instanceof NavigationStart)).subscribe(event => {
            this.lastNavigationWasPopstate = event.navigationTrigger === 'popstate';
        });
    }

    setContext(context: Context): void {
        this.contextRs$.next(context);
    }

    /**
     * returns a boolean based on in the tab and or window is active
     */
    public isActiveWindow(): boolean {
        return !this.document.hidden && this.document.hasFocus();
    }
}
